export const SETTINGS_RECEIVED = "SETTINGS_RECEIVED";
export const SETTING_UPDATED = "SETTING_UPDATED";